/**
  * Highlight "Sale" menu items in red across all header menus
 */

const SALE_MENU_COLOR = '#EB1C24';

function isSaleMenuLabel(text) {
  const normalized = text.trim().toLowerCase();
  return normalized === 'shock price sale' || normalized === 'shock price sales';}

function highlightSalesMenuItems() {
  const selectors = [
    '.menu-drawer__menu-link',
    '.menu-drawer__submenu-list-link',
    '.mega-menu__column-heading',
    '.mega-menu__column-list-link',
    '.mega-menu__tab span',
    '.header__submenu a',
  ];

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(element => {
      const text = element.textContent?.trim() || '';
      if (!isSaleMenuLabel(text)) return;

      const target = element.querySelector('h6, span') || element;
      target.style.color = SALE_MENU_COLOR;
    });
  });
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', highlightSalesMenuItems);
} else {
  highlightSalesMenuItems();
}

// Re-run when Shopify sections load dynamically
document.addEventListener('shopify:section:load', highlightSalesMenuItems);

// Re-run periodically for dynamically added content
const observer = new MutationObserver(highlightSalesMenuItems);
observer.observe(document.body, { 
  childList: true, 
  subtree: true,
  attributes: false
});
